import { render, staticRenderFns } from "./TVCommentButton.vue?vue&type=template&id=37e66850&"
import script from "./TVCommentButton.vue?vue&type=script&lang=ts&"
export * from "./TVCommentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports